/**
 * Processes Contentful data
 * 
 * @param {Array} data - Array of Contentful entries
 * @returns {Array} - Processed array of entries
 */
export const processContentfulData = (data) => {
  if (!Array.isArray(data)) {
    console.error('processContentfulData: Input must be an array');
    return [];
  }

  return data;
};

/**
 * Formats a single Contentful entry for display
 * 
 * @param {Object} entry - Single Contentful entry
 * @returns {Object} - Formatted entry
 */
export const formatContentfulEntry = (entry) => {
  if (!entry) return null;

  // Preserve the original entry structure while adding formatted fields
  return {
    ...entry,
    fields: {
      ...entry.fields,
      title: entry.fields?.title,
      excerpt: entry.fields?.excerpt,
      pageHeaderImage: entry.fields?.pageHeaderImage,
      body: entry.fields?.body,
      videoOrSecondaryImage: entry.fields?.videoOrSecondaryImage,
      featuredImage: entry.fields?.featuredImage,
      author: entry.fields?.author,
      publishDate: entry.fields?.publishDate,
      tags: entry.fields?.tags,
      image: entry.fields?.image,
      description: entry.fields?.description
    }
  };
};

/**
 * Processes and formats Contentful data
 * 
 * @param {Array} data - Raw Contentful data
 * @returns {Array} - Processed and formatted data
 */
export const processAndFormatContentfulData = (data) => {
  const processedData = processContentfulData(data);
  return processedData.map(formatContentfulEntry);
};

/**
 * Paginates an array of items
 * 
 * @param {Array} items - Array of items to paginate
 * @param {number} currentPage - Current page number (1-based)
 * @param {number} itemsPerPage - Number of items per page
 * @returns {Object} - Object containing paginated items and pagination info
 */
export const paginateItems = (items, currentPage = 1, itemsPerPage = 6) => {
  const totalItems = items.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedItems = items.slice(startIndex, endIndex);

  return {
    items: paginatedItems,
    pagination: {
      currentPage,
      totalPages,
      totalItems,
      itemsPerPage,
      hasNextPage: currentPage < totalPages,
      hasPreviousPage: currentPage > 1
    }
  };
}; 